module.exports = __webpack_public_path__ + "media/images/shared/icon-identification-85ba9298107fa78a8ccc31ce1373586c.png";